/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

type Props = {
    onObserve?: (values: Record<string, any>) => void
};

const OnahFormObserver: React.FC<Props> = ({onObserve}) => {
    const { values } = useFormikContext<Record<string, any>>();
    useEffect(() => {
        onObserve && onObserve(values);
    }, [values]);

    return null;
};

export default OnahFormObserver;